import { IssueRecipientModel } from "./issueRecipientModel";
import { OtherRecipients } from "./OtherRecipients";

export class SendDetailsModel {
    public IssueWebId: number;
    public IssueNumber: number;
    public Recipients: IssueRecipientModel[];
    public otherRecipients: OtherRecipients[];
    public additionalMessage: string;
}




// WEBPACK FOOTER //
// ./src/app/models/SendDetailsModel.ts